import {Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
import {SeedData} from './citationTrailsBreadcrumbs.directive';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {CitationTrailsBreadcrumbsService} from './citationTrailsBreadcrumbs.service';
import {FullViewDialogService} from '../fullView/fullViewDialog.service'
import {FullViewPageService} from '../fullView/fullViewPage/fullViewPage.service';
import {TemplateUtil} from '../../nddUtils/templateUtil.service';
import {IState} from 'angular-ui-router';
import {ChangeLangService} from '../../infra/lang/changeLang.service';

@Component({
	directives: [],
	selector: 'prm-citation-trails-item',
	templateUrl: 'components/search/citationTrails/citation-trails-item.html'
})

export class PrmCitationTrailsItem {
	@Input() public seed : SeedData;
	@Input() public index: number;
    @Input() private zOrder: string;
    @Output() private changeActiveSeedEvent: EventEmitter<Object>= new EventEmitter();
	public CITATION_TRAILS_STATE = STATE_NAMES.CITATION_TRAILS;
    private _deepLinkPath: string;
    private getItemPromise: angular.IPromise;

	constructor(@Inject('$state') private $state: IState,
                @Inject('$stateParams') private $stateParams,
				private ctBreadcrumbsService:CitationTrailsBreadcrumbsService,
			 	private fullViewDialogService: FullViewDialogService, 
                private fullViewPageService: FullViewPageService,
                private templateUtil: TemplateUtil,
                private changeLangService: ChangeLangService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService){

	}

	private ngOnInit(){
        if(!this.seed.record){
            this.getItemPromise= this.fullViewPageService.getItemById(this.seed.recordId, null, 'PC', this.$stateParams.search_scope , 'primo_central_multiple_fe', false, false).then((response)=>{
                this.seed.record= response.data;
            });
        }
    }

	private ngAfterViewInit(){
        if (this.changeLangService.direction === 'rtl'){
            document.querySelector(".horizontal-content-scroller").scrollLeft=0;
        }
        else{
            document.querySelector(".horizontal-content-scroller").scrollLeft=100000;
        }

    }
    
    get deepLinkPath(){
        if(this.seed.record){
            return this.templateUtil.getFullDeepLinkAbsPath(this.seed.record);
        }
    }
    
    private openFullView($event){
        if (this.seed.record){
            this.fullViewDialogService.openFullViewDialog(this.seed.record, $event, 'citationTrailsItem');
        }
        else {
            this.getItemPromise.then(()=>{
                this.fullViewDialogService.openFullViewDialog(this.seed.record, $event, 'citationTrailsItem');
            });
        }
    }
    
    private onItemClick(index, citation, $event){
        $event.preventDefault(); //do not open the href
        if (this.isActive()){
            this.openFullView($event);
            return;
        }
        this.changeActiveSeedEvent.emit({index: index});
    }

	get citationType(){
        return this.seed.citeType;
	}

	public isActive(){
		return this.index == this.ctBreadcrumbsService.seeds.getActiveLevel();
	}

	get activeLevel(){
		return this.ctBreadcrumbsService.seeds.getActiveLevel();
	}

    public isActiveSeed(){
        if (this.index == this.ctBreadcrumbsService.seeds.getActiveLevel()) {
            return 'nui.citation_trail.link.active_Seed';
        }

        return "";
    }

    public activeCitationType () {
        if (this.citationType === 'citing') {
            return this.$translate.instant('nui.citation_trail.link.citing.activeSeed');
        }

        if (this.citationType === 'citedby') {
            return this.$translate.instant('nui.citation_trail.link.citedin.activeSeed');
        }
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsItem.directive.ts